import React from "react";
import styles from './DashboardStudentCard.module.scss';
import { Link } from "react-router-dom";
import ProfilePicture from "../profilePicture/ProfilePicture";
import PropTypes from "prop-types";

const DashboardStudentCard = ({
  student,
  completed,
  total
}) => {
  const percentage = total === 0 ? 0 : Math.round(completed / total * 100);
  return (
    <div className={styles.card}>
      <div className={styles.details}>
        <ProfilePicture {...student} />
        <div className={styles.content}>
          <span>{student.firstName} {student.lastName}</span>
          <div className={styles.progressBar}>
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="10" fill="none">
              <rect x="0.447021" y="0.732422" width="100%" height="8.53556" rx="4.26778" fill="#E97100"/>
              <rect x="0.447021" y="1" width={`${percentage}%`} height="8" rx="4" fill="#388147"/>
            </svg>
            <span>{completed}/{total}</span>
          </div>
          <div className={styles.percentage}>
            <div className={styles.percentageItem}>
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.421875" width="14.6416" height="15" rx="7.3208" fill="#388147"/>
              </svg>
              {percentage}% Completed
            </div>
            <div className={styles.percentageItem}>
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.421875" width="14.6416" height="15" rx="7.3208" fill="#E97100"/>
              </svg>
              {100 - percentage}% Pending
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Link to={`/student-overview/${student.id}`}>
          Visit Profile
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 14" fill="none">
            <path d="M0.613281 13L6.46992 7L0.613281 1" stroke="#0461FF" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>
      </div>
    </div>
  );
};

DashboardStudentCard.propTypes = {
  student: PropTypes.object.isRequired,
  completed: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}

export default DashboardStudentCard;